import React from 'react'
import _ from 'lodash'

import Grid from './grid'

import {Leg} from '../leg/leg.component'


export class LegGrid extends React.Component {
    constructor(props) {
        super(props)

        this.grid = null

        this.initGrid = this.initGrid.bind(this)
        this.componentDidUpdate = this.componentDidUpdate.bind(this)
    }

    componentDidMount() {
        window.addEventListener('resize', _.debounce(() => {
            this.resizeGrid()
        }, 250))
    }

    initGrid(component) {
        if (!_.isNull(this.grid)) {
            return
        }

        let findLeg = (legId) => {
            return this.props.legs.find((leg) => {
                return leg.get('id') === legId
            })
        }

        let fromGrid = (coord) => coord / this.props.columnsPerDay

        this.grid = Grid(component, {
            didMove: (legs) => {
                this.props.onMoveLegs(_.map(legs, (gridLeg) => {
                    return {
                        leg: findLeg(gridLeg.id),
                        start: fromGrid(gridLeg.x),
                    }
                }))
            },
            didResize: (legs) => {
                this.props.onResizeLegs(_.map(legs, (gridLeg) => {
                    let start = fromGrid(gridLeg.x)

                    return {
                        leg: findLeg(gridLeg.id),
                        start: start,
                        end: start + fromGrid(gridLeg.w)
                    }
                }))
            }
        })

        this.resizeGrid()
    }

    componentDidUpdate() {
        this.resizeGrid()
    }

    resizeGrid() {
        this.grid.size(this.props.width, this.props.columns)
        this.grid.initDOM('.leg-grid .leg-wrapper')
    }

    renderLegs() {
        return this.props.legs.valueSeq().map((leg) => {
            let x = leg.getIn(['properties', 'start']) * this.props.columnsPerDay
            let w = leg.getIn(['properties', 'length']) * this.props.columnsPerDay

            // TODO: We need a better method to compare, maybe store user id or guid in presenece object
            let curUserName = this.props.currentUser ? this.props.currentUser.firstname + ' ' + this.props.currentUser.lastname : ''

            let activeUsers = this.props.presence.filter((presence) => {
                return presence.get('leg') == leg.get('id') && presence.get('name') != curUserName
            })

            return (
                <div
                    className="leg-wrapper"
                    key={leg.get('id')}
                    data-x={x} data-w={w} data-id={leg.get('id')}>
                    <Leg
                        key={'leg-' + leg.get('id')}
                        leg={leg}
                        activeUsers={activeUsers}
                        onDeleteLeg={this.props.onDeleteLeg}
                        isActive={leg.get('id') === this.props.activeLeg}
                        onActivateLeg={this.props.onActivateLeg}
                        quicktoolsEvents={this.props.quicktoolsEvents}
                        quickcollabsEvents={this.props.quickcollabsEvents}/>
                </div>
            )
        })
    }

    render() {
        return (
            <div id="leg-block-container">
                <div className="leg-grid" ref={this.initGrid}>
                    {this.renderLegs()}
                </div>
            </div>
        )
    }
}
